import { z } from 'zod'

export const schema = z.object({})

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  path: z.string(),
  parameters: z.string().nullable(),
  totalResults: z.number().nullable(),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
